'use memo';

import { StatCardContent, StatCardHighlight, StatCardPrimaryValue, StatCardSecondaryValue, StatCardTable, StatCardTableHorizBar, StatCardTableRow, StatCardValueContainer } from '@/components/Card/StatCard';
import Spacer from '@/components/Layout/Spacer';
import { Text } from '@/components/Typography';
import { Separator } from '@/components/ui/separator';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { BentoCard } from './BentoCard';
export type AccessClassificationData = {
  all: number;
  registered: number;
  tolerated: number;
  blocked: number;
};

/** カード1: 検知アプリ（連携カバレッジ＝登録済み / 未登録）。 */
export function AccessClassificationCard({
  data
}: {
  data: AccessClassificationData;
}) {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.accesses.overview'
  });
  const unregistered = Math.max(0, data.all - data.registered);
  const rows = [{
    key: 'registered',
    label: t('registered'),
    value: data.registered
  }, {
    key: 'unregistered',
    label: t('unregistered'),
    value: unregistered
  }];
  return <BentoCard title={t('detectedApps')}>
      <StatCardHighlight className="py-2">
        <StatCardValueContainer>
          <StatCardPrimaryValue>
            {data.all.toLocaleString()}
          </StatCardPrimaryValue>
          <StatCardSecondaryValue>{t('appUnit')}</StatCardSecondaryValue>
        </StatCardValueContainer>
      </StatCardHighlight>
      <Spacer variant="xs" />
      <Separator />
      <Spacer variant="xs" />
      <StatCardContent>
        <StatCardTable>
          {rows.map(row => <StatCardTableRow key={row.key}>
              <Text variant="pSmall" className="whitespace-nowrap text-neutral-muted-on-fill">
                {row.label}
              </Text>
              <StatCardTableHorizBar value={row.value} maxValue={data.all} />
              <span />
            </StatCardTableRow>)}
        </StatCardTable>
      </StatCardContent>
    </BentoCard>;
}